<template>
  <div class="container">

      <div class="form-row">
        <div class="form-group col-sm-4 headerTask">
          <h2>Gestion des paramètres</h2>
        </div>
        <!-- SEARCH -->
      </div>
      <!-- -->
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Type</th>
            <th>Valeur</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(parameter,index) in defaultParameters" :key="index">
            <td>{{ parameter.name }}</td>
            <td>{{ formattedParameter(parameter.relatedTypeId) }}</td>
              <td><input
              type="number"
              v-model="parameter.defaultValue"
              v-bind:disabled="parameter.disabled"
            ></td>
            <td>
              <div v-show="parameter.disabled" class="inline">
              <button type="submit" class="btn btn-action btn-sm" @click="edit(parameter)">
                <i class="material-icons">edit</i>
              </button>
            </div>

            <div v-show="!parameter.disabled" class="inline">
              <button type="submit" class="btn btn-action btn-sm inline" @click="cancel(parameter)">
                <i class="material-icons">cancel</i>
              </button>
              
              <button type="submit" class="btn btn-action btn-sm inline" @click="save(parameter)">
                <i class="material-icons">done</i>
              </button>
            </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>


<script>
import { mapState, mapGetters } from "vuex";
import KezInput from "@/components/_forms/KezInput";
import KezSelect from "@/components/_forms/KezSelect";
import Search from "@/components/search/Search";

export default {
  components: {
    KezInput,
    KezSelect,
    Search
  },
  data() {
    return {
      isAdd: true,
      show: false
    };
  },
  computed: {
    ...mapState("parameters", ["parameter", "defaultParameters"]),
    ...mapState("parameterTypes", [
      "formattedParameterTypes",
      "formattedParameter"
    ]),
    ...mapGetters("parameters", ["calculMin", "calculMax"]),
    ...mapGetters("parameterTypes", [
      "formattedParameterTypes",
      "formattedParameter"
    ])
  },
  mounted() {
    this.$store.dispatch("parameters/getDefault");
    this.$store.commit("parameters/parameter", {});
    this.$store.dispatch("parameterTypes/getList");
  },
  methods: {
    edit(parameter) {
      if (parameter.disabled == undefined) {
        parameter.disabled = true;
      } else {
        parameter.disabled = parameter.disabled == true ? false : true;
      }
      parameter.oldValue = parameter.defaultValue;

      this.parameter;
    },
    save(parameter) {
      this.$store.dispatch("parameters/save", parameter);
    },
    reset() {
      this.$store.commit("parameters/parameter", {});
      this.$store.dispatch("parameters/getDefault");
      this.isAdd = true;
    },
    cancel(parameter) {
      parameter.disabled = true;
      parameter.defaultValue = parameter.oldValue;
    }
  }
};
</script>

